export const getRequiredMessage = (fieldName: string) =>
  `Поле "${fieldName}" не может быть пустым`;
